"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 转融通可冲抵保证金证券及折算率
 */
require("emdataview");
var base_1 = __importDefault(require("./base"));
var public_1 = require("./public");
var date;
public_1.changeDayPage(4);
function init() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, public_1.showDate()];
                case 1:
                    date = _a.sent();
                    $('#search_date_end').val(date);
                    $('.date').text(date);
                    // 获取完时间，绑定时间再渲染table数据
                    params.filter = "(TRADE_DATE='" + date + "')";
                    $("#dayZrtDeposit").emdataview(opt_dayZrtDeposit);
                    // 切换日期更改列表数据
                    $('#changeDate').on('click', function () {
                        date = $('#search_date_end').val();
                        $('.date').text(date);
                        // 获取完时间，绑定时间再渲染table数据
                        params.filter = "(TRADE_DATE='" + date + "')";
                        $("#dayZrtDeposit").emdataview(opt_dayZrtDeposit);
                    });
                    return [2 /*return*/];
            }
        });
    });
}
init();
var params = {
    reportName: 'RPT_REFINANCING_TARGET',
    columns: "ALL",
    quoteColumns: "",
    source: "WEB",
    client: "WEB",
    pageNumber: 1,
    pageSize: 50,
};
var opt_dayZrtDeposit = {
    dataurl: {
        hostname: "datacenter",
        url: "api/data/v1/get",
        params: params
    },
    sortname: "EFFECTIVE_DATE",
    urlkeyvalues: base_1["default"].urlkeyvalues,
    columns: {
        SECURITY_CODE: emfield.code,
        SECURITY_NAME_ABBR: emfield.name,
        xiangguan: {
            formatter: function (value, item) {
                return "\n        <a href=\"/zjlx/" + item.SECURITY_CODE + ".html\" class=\"red\">\u8D44\u91D1\u6D41</a>\n        <a href=\"//guba.eastmoney.com/topic," + item.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
            }
        }
    }
};
